import ContentWrp from './ContentWrp';

export default ContentWrp;
